import { Component, input } from '@angular/core';

import { IconCircleComponent } from '@core/getting-started-legacy';
import type { TellentAppsBrand } from '@core/tellent-types';

import { OrgBrandLogoComponent } from '../org-brand-logo/org-brand-logo.component';

@Component({
  selector: 'tla-start-free-trial-dialog-success-lib',
  template: `
    <div class="symbol">
      <tl-org-brand-logo-lib size="64" [brand]="brand()" />
      <rt-icon-circle size="large" iconName="check" iconColor="colorIconActive" />
    </div>

    <svg
      width="150"
      height="3"
      viewBox="0 0 150 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      margin-tb
    >
      <path
        d="M0 1.66231C1.51367 1.59988 3.02167 1.54882 4.53534 1.50342V1.88367C3.02167 1.85529 1.51367 1.82692 0 1.78151V1.66231Z"
        fill="#1D1D1B"
      />
      <path
        d="M9.07031 1.3666L13.6055 1.2644L13.6112 2.00232L9.07598 1.95691L9.07031 1.3666Z"
        fill="#1D1D1B"
      />
      <path
        d="M18.1406 1.1737L22.676 1.11694L22.6817 2.04226L18.1463 2.03658L18.1406 1.1737Z"
        fill="#1D1D1B"
      />
      <path
        d="M27.2129 1.06039C28.7266 1.03769 30.2346 1.01498 31.7483 1.02066L31.7539 2.02523C30.2403 2.04793 28.7322 2.04795 27.2186 2.04228L27.2129 1.06039Z"
        fill="#1D1D1B"
      />
      <path
        d="M36.2832 1.01478C37.7969 1.00911 39.305 1.02616 40.8187 1.04319L40.8244 1.88313C39.3106 1.91719 37.8026 1.95693 36.2889 1.96828L36.2832 1.01478Z"
        fill="#1D1D1B"
      />
      <path
        d="M45.3535 1.09424L49.8888 1.14534L49.8945 1.67327L45.3592 1.78113L45.3535 1.09424Z"
        fill="#1D1D1B"
      />
      <path
        d="M54.4238 1.17407L58.9592 1.17975L58.9648 1.53166L54.4295 1.59409L54.4238 1.17407Z"
        fill="#1D1D1B"
      />
      <path
        d="M63.4961 1.13949L68.0315 1.08838L68.0372 1.50851L63.5018 1.51416L63.4961 1.13949Z"
        fill="#1D1D1B"
      />
      <path
        d="M72.5664 0.992003L77.1018 0.895508L77.1075 1.58806L72.5721 1.54832L72.5664 0.992003Z"
        fill="#1D1D1B"
      />
      <path
        d="M81.6367 0.79333L86.1721 0.713867L86.1778 1.65595L81.6424 1.63326L81.6367 0.79333Z"
        fill="#1D1D1B"
      />
      <path
        d="M90.707 0.640212L95.2424 0.589111L95.248 1.67328H90.7127L90.707 0.640212Z"
        fill="#1D1D1B"
      />
      <path
        d="M99.7793 0.532333L104.315 0.475586L104.32 1.67323H99.785L99.7793 0.532333Z"
        fill="#1D1D1B"
      />
      <path
        d="M108.85 0.4528L113.385 0.435791L113.391 1.59931L108.855 1.63904L108.85 0.4528Z"
        fill="#1D1D1B"
      />
      <path
        d="M117.92 0.418784C119.434 0.407431 120.942 0.413113 122.455 0.424466L122.461 1.50297C120.947 1.53135 119.439 1.55405 117.926 1.5654L117.92 0.418784Z"
        fill="#1D1D1B"
      />
      <path
        d="M126.99 0.441406L131.526 0.464096L131.531 1.34947L126.996 1.42326L126.99 0.441406Z"
        fill="#1D1D1B"
      />
      <path
        d="M136.062 0.509521L140.598 0.566275V1.13963L136.062 1.24749V0.509521Z"
        fill="#1D1D1B"
      />
      <path
        d="M145.133 0.640381L149.668 0.731156V0.861691L145.133 1.00355V0.640381Z"
        fill="#1D1D1B"
      />
    </svg>

    <div class="copy">
      <div class="heading">{{ texts().heading }}</div>
      <div class="description">{{ texts().description }}</div>
    </div>
  `,
  styleUrls: ['./start-free-trial-dialog-success.component.less'],
  imports: [IconCircleComponent, OrgBrandLogoComponent],
})
export class StartFreeTrialDialogSuccessComponent {
  public brand = input.required<TellentAppsBrand>();
  public texts = input.required<{
    heading: string;
    description: string;
  }>();
}
